import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IExtractState } from '../state/IExtractState';
import { extractsStateReducer } from './extracts-reducer';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';
import { ExtractListModel } from '../../../extracts/models/ExtractListModel';

export interface ExtractsModuleState {
  extractState: IExtractState,
};

export const reducers = {
  extractState: extractsStateReducer
};

export const getExtractsModuleState = createFeatureSelector('extracts');
export const getExtractState = createSelector(getExtractsModuleState, (s: ExtractsModuleState) => s.extractState);
export const getExtractCategoryList = createSelector(getExtractState, (s: IExtractState) => s.extractCategories);
export const getExtractCategoryListLoading = createSelector(getExtractState, (s: IExtractState) => s.extractCategoryLoading);
export const getExtractCategorySelected = createSelector(getExtractState, (s: IExtractState) => s.extractCategorySelected);
export const getExtractList = createSelector(getExtractState, (s: IExtractState) => s.extractList);
export const getExtractListTotalCount = createSelector(getExtractState, (s: IExtractState) => s.extractListTotalCount);
export const getExtractListLoading = createSelector(getExtractState, (s: IExtractState) => s.extractListLoading);
export const getExtractListCurrentPage = createSelector(getExtractState, (s: IExtractState) => s.extractListCurrentPage);
export const getExtractListSelection = createSelector(getExtractState, (s: IExtractState) => s.extractListSelected);
export const getExtractWorkspaceList = createSelector(getExtractState, (s: IExtractState) => s.extractWorkspaceList);
export const getExtractWorkspaceListTotalCount = createSelector(getExtractState, (s: IExtractState) => s.extractWorkspaceListTotalCount);
export const getExtractWorkspaceListLoading = createSelector(getExtractState, (s: IExtractState) => s.extractWorkspaceListLoading);



// WEBPACK FOOTER //
// ./src/app/extracts/store/reducers/index.ts